export enum ACTION_BUTTON_MODE {
    ASSIGN_LESSON = 'assign_lesson',
    ASSIGN_IN_EXTERNAL_LMS = 'assign_in_external_lms',
    REASSIGN_LESSON = 'reassign_lesson',
    EDIT_ASSIGNMENT = 'edit_assignment',
    SAVE_ASSIGNMENT = 'save_assignment',
    FORCE_COMPLETE_LESSON = 'force_complete_lesson',
    LESSON_COMPLETED = 'lesson_completed',
    ASSIGNMENT_DISABLED = 'assignment_disabled',
    DELETE_LESSON = 'delete_lesson',
}
